<template>
  <div>
    <base-dialog :show-dialog="showDialog">
      <template v-slot:body>
        <v-card dark>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="warning rounded-lg px-2 py-2">
                  <span class="text-subtitle-1 white--text font-weight-regular">
                    {{ $t('pdv.enviarOrcamentoDialogText') }}
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-2" @click="$emit('close-dialog')" small>
              <span class="text-button font-weight-regular">{{
                $t('labels.voltar')
              }}</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green" @click.prevent="$emit('close-order')" small>
              <span class="text-button font-weight-regular white--text">{{
                $t('labels.confirmar')
              }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
export default {
  components: { BaseDialog },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
